
import React, { useState, useEffect } from "react";
import { Box, Button, Grid, makeStyles, Typography, TextField } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import apiHelper from "../../../util/ApiHelper";
import { toast } from "react-toastify";
import editorConfiguration from "../../../util/EditorConfiguration";
import { useLoading } from "../../../util/LoadingProvider";
import {
    InputAdornment,
  } from "@material-ui/core";

const defaultFormValues = {
    contentEn: "",
    contentTc: "",
};

const useStyles = makeStyles((theme) => ({
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "362px",
        },
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
    },
}));

export default function FestivalPassNoticePage({ disabled, ...props }) {
    const [defaultValues] = useState(defaultFormValues);
    const [initialValues, setInitialValues] = useState({});
    const [id, setId] = useState();
    const { setLoading } = useLoading();

    const classes = useStyles();

    const {
        control,
        handleSubmit,
        setValue,
    } = useForm({
        defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    });

    const onSubmit = (value) => {
        updateFestivalPassNotice(value);
    };

    const getFestivalPassNotice = async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getPageWordByType('festivalpass','collect');
            console.log(result);
            setInitialValues(result.data.content[0]);
            setId(result.data.content[0].id);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const updateFestivalPassNotice = async (value) => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.updatePageWordById(id, value);
            console.log(result);
            if (result.status === 200) {
                toast.dark("Your changes are saved.");
                await getFestivalPassNotice();
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFestivalPassNotice();
    }, []);

    return (
        <div className={classes.content}>
            <Box width="100%">
                <Typography variant="h4" gutterBottom>
                    Ticket & FAQ > Festival Pass Notice
        </Typography>
            </Box>
            {initialValues ? (
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Box fontWeight={900} fontSize={13} mb={2} width="100%">
                        <Typography variant="p">Description (English)</Typography>
                    </Box>

                    <Grid item xs={12}>
                        <Controller
                            name="contentEn"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <CKEditor
                                    editor={Editor}
                                    config={editorConfiguration}
                                    data={field.value}
                                    disabled={disabled}
                                    onReady={(editor) => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log("Editor is ready to use!", editor);
                                        editor.setData(initialValues.contentEn);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                        // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Box fontWeight={900} fontSize={13} mt={4} mb={2} width="100%">
                        <Typography variant="p">Description (Traditional Chinese)</Typography>
                    </Box>

                    <Grid item xs={12}>
                        <Controller
                            name="contentTc"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <CKEditor
                                    editor={Editor}
                                    config={editorConfiguration}
                                    data={field.value}
                                    disabled={disabled}
                                    onReady={(editor) => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log("Editor is ready to use!", editor);
                                        editor.setData(initialValues.contentTc);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                        // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    {disabled || (
                        <div className={classes.buttonGroup}>
                            <Button
                                type="submit"
                                variant="contained"
                                disableElevation
                                style={{
                                    color: "white",
                                    background: "#306F9D",
                                    marginRight: "5px",
                                    padding: "9px 16px",
                                }}
                            >
                                Save
              </Button>
                        </div>
                    )}
                </form>
            ) : (
                    <></>
                )
            }
        </div >
    );
}
